export interface IPoItem {
  id: number;
  stockCaseQuantity: number;
  itemDRSValue: number;
  receivedQuantity: number;
  matchStatusMap?: Record<string, number>;
}

export function findMatchingSubset(poiItems: IPoItem[], number: number) {
  const result: IPoItem[] = [];

  function backtrack(startIndex: number, currentSum: number, currentSubset: IPoItem[]): boolean {
    if (currentSum === number) {
      result.push(...currentSubset);
      return true;
    }
    if (currentSum > number) {
      return false;
    }
    for (let i = startIndex; i < poiItems.length; i++) {
      const value = Math.round(
        poiItems[i].stockCaseQuantity *
        poiItems[i].itemDRSValue *
        poiItems[i].receivedQuantity *
        100
      ) / 100;
      currentSubset.push(poiItems[i]);
      if (backtrack(i + 1, currentSum + value, currentSubset)) {
        return true;
      }
      currentSubset.pop();
    }
    return false;
  }

  if (backtrack(0, 0, [])) {
    return result;
  }

  return null;
}